<template>
    <button
        class="button button_theme_content-width button_theme_light button_theme_stroke"
        v-if="borderShow > 0"
        @click="changePage"
    >
        Загрузить ещё {{ borderShow }} из {{ counterFlats }}
    </button>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
    data() {
        return {
            itemOnPage: this.$appOptions.showParkingsPage
        };
    },
    props   : ['counterHidden', 'counterFlats'],
    computed: {
        ...mapGetters({page: 'GET_PAGE'}),

        borderShow() {
            const hidden = this.counterHidden;

            return hidden < this.$appOptions.showParkingsPage ? hidden : this.$appOptions.showParkingsPage;
        }
    },

    methods: {
        ...mapActions(['changePage'])
    }

};

</script>
